import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-ver-certificado-dialog',
  templateUrl: './ver-certificado-dialog.component.html',
  styleUrls: ['./ver-certificado-dialog.component.scss']
})
export class VerCertificadoDialogComponent implements OnInit {
  formattedJson: string = '';
  title: string = 'Certificado';
  isHFC: boolean = false;
  isFTTH: boolean = false;
  isTV: boolean = false;
  isTelephony: boolean = false;
  hfcResult: any = null;
  ftthResult: any = null;
  tvResult: any = null;
  telephonyResult: any = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<VerCertificadoDialogComponent>,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit() {
    this.setTitle();
    this.parseData();
  }

  private setTitle() {
    const tipo = this.data.TIPO || '';
    const tipoUpper = tipo.toString().toUpperCase();
    
    if (tipoUpper.includes('HFC')) {
      this.title = 'Certificado HFC';
      this.isHFC = true;
    } else if (tipoUpper.includes('FTTH')) {
      this.title = 'Certificado FTTH';
      this.isFTTH = true;
    } else if (tipoUpper.includes('TV')) {
      this.title = 'Certificado TV';
      this.isTV = true;
    } else if (tipoUpper.includes('TELEFONIA') || tipoUpper.includes('TELEFONÍA') || tipoUpper.includes('TEL')) {
      this.title = 'Certificado TELEFONIA';
      this.isTelephony = true;
    } else {
      this.title = 'Certificado';
    }
  }

  private parseData() {
    try {
      const jsonData = this.data.DATA_JSON;
      let parsed: any;
      
      if (typeof jsonData === 'string') {
        parsed = JSON.parse(jsonData);
      } else {
        parsed = jsonData;
      }
      
      if (this.isHFC) {
        this.hfcResult = parsed;
      } else if (this.isFTTH) {
        this.ftthResult = parsed;
      } else if (this.isTV) {
        this.tvResult = parsed;
      } else if (this.isTelephony) {
        this.telephonyResult = parsed;
      } else {
        this.formattedJson = JSON.stringify(parsed, null, 2);
      }
    } catch (e) {
      if (this.isHFC) {
        this.hfcResult = null;
      } else if (this.isFTTH) {
        this.ftthResult = null;
      } else if (this.isTV) {
        this.tvResult = null;
      } else if (this.isTelephony) {
        this.telephonyResult = null;
      } else {
        this.formattedJson = typeof this.data.DATA_JSON === 'string' 
          ? this.data.DATA_JSON 
          : JSON.stringify(this.data.DATA_JSON);
      }
    }
  }

  copyToClipboard() {
    const textArea = document.createElement('textarea');
    textArea.value = this.formattedJson;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      this.snackbar.open('JSON copiado al portapapeles', 'Cerrar', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    } catch (err) {
      this.snackbar.open('Error al copiar al portapapeles', 'Cerrar', {
        duration: 2000
      });
    } finally {
      document.body.removeChild(textArea);
    }
  }

  close() {
    this.dialogRef.close();
  }
}

